import React, { FC } from "react"

import SEO from "@components/SEO/SEO"

import { PostTemplateQueryQuery } from "@graphqlTypes"

const PostHead: FC<{ data: PostTemplateQueryQuery }> = ({
  data: {
    contentfulPost,
  },
}) => {
  if (!contentfulPost) return null

  const {
    authors,
    category,
    description,
    image,
    permalink,
    seoNoindex,
    seoTitle,
    thumbnailImage,
    title,
  } = contentfulPost

  return (
    <SEO
      category={category && category[0] && category[0].title}
      creator={authors && authors[0] && authors[0].twitter}
      description={description?.description || ""}
      image={
        (
          thumbnailImage
            ? thumbnailImage?.imgixImage?.url
            : image?.imgixImage?.url
        ) || ""
      }
      permalink={permalink || "/"}
      robots={seoNoindex ? "noindex,nofollow" : undefined}
      title={seoTitle || title || ""}
      type="article"
    />
  )
}

export default PostHead
